var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ping-container"},[_c('div',{staticClass:"ping-wrapper",class:{'show-ping' : _vm.show}},[_c('span',{staticClass:"ping-dot"}),_c('span',{staticClass:"ping-anim"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }